export const SWAP_KO_default = [{
    strike_floor : 1,
    strike_ko: 3,
    prime_de_couverture: 10
}]



// WEBPACK FOOTER //
// ./src/shared/Cotation/chart/data/default/SwapKO.ts